var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  strokeWidth: 2,
  stroke: "currentColor"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3.5,
  y: 4.5,
  width: 17,
  height: 15,
  rx: 1.5,
  strokeLinejoin: "round"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.5 9.5h17M3.5 14.5h17M9 9.5V19.5"
})));
export default SvgChartTable;